import SearchNormalIcon from '@/common/assets/icons/searchNormalIcon.svg?react';
import createAttachment from '@/common/components/base/input/base/helpers/createAttachment.ts';

const searchAttachment = ({ shouldRender }: { shouldRender: boolean }) => {
  return createAttachment({
    element: <SearchNormalIcon />,
    shouldRender: shouldRender,
    size: 'small',
  });
};
export default searchAttachment;
